(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name dutySheet.controller:DutySheetCtrl
	 *
	 * @description
	 *
	 */
	angular
		.module('dutySheet')
		.directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
		.controller('DutySheetCtrl', DutySheetCtrl);

	function DutySheetCtrl(CommonMasterData, EventManagerService, DutySheetService, MessageService,
			PopupManager, StorageServices, TabService, ManageFlightService,
			FlightWatch,CrewingHelper,CommonLogicService, $timeout,$interval,applicationConstants,$scope) {
		var vm = this;
		var lastRightClickedBlock = null;
		var openedPopoverBlock = null;
		vm.ctrlName = 'DutySheetCtrl';
		vm.limitIndex = 30;
	    vm.isBusyInRendering = false;

		vm.model = {
			searchPanelToggle : true,
			initialSearchDone : false,
			legalities : null,
			searchCriteria : {
				fromDate : moment(new Date()).format('DD/MM/YYYY'),
				toDate : moment(new Date()).format('DD/MM/YYYY'),
				fromTime : '00:00',
				toTime : '23:59',
				JourneyLogNo : null,
				aircraftType : null,
				crewType : null,
				airport : null,
				isDestinationOnly : null,
        base : null
			},
			masterList : {
				aircraftTypes : [],
				crewTypeMasterCodes : [],
				airportList : [],
				fromTimeInvalid : false,
				toTimeInvalid : false,
				baseList:[],
				tooltipFlights:[],
				crewTypeList :  [],
        searchFrom : null
			},
      exportDutyList : [],
      exportStandbyList : [],
			duties : []
			// grid data
			,
			showBottomPanel : false,
			otherDuties : {
				standByDetails : [],
				deadHeadingDetails : [],
				readyToWorkDetails : [],
				reportSickDetails : [],
				otherDutyTypeDetails : []
			},
			// bottom grid data
			selectedDuty : {},
			selectedStandBy : [],
			selectedDHD : {},
			showNewGD : false,
			printSeparateGDForCrewTypes : false,
      refreshData:true,
      lastScrollPosition :0,
      bottomLastScrollPosition:0,
      refreshingTime:0,
      dutySheetHidePersonalDetailsEnabled: false,
      carrierCode: null
		};

		EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

		vm.popOverFlag = false;

		// to hide and show search panel
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		function getNextSetOfRecords() {
	    	if(!vm.isBusyInRendering){
	    		vm.limitIndex = (vm.model.duties.length + vm.limitIndex) < vm.dutyList.length ? vm.limitIndex : vm.dutyList.length-vm.model.duties.length;
	        	for(var i = 0, asyncIndex = 0, index = vm.model.duties.length ; i < vm.limitIndex; i++){
//	    			$timeout(function(){
	    				vm.isBusyInRendering = true;
	    				vm.model.duties.push(vm.dutyList[index]);
	    				index++;
	    				asyncIndex++;
	    				if(asyncIndex == vm.limitIndex){
	    					vm.isBusyInRendering = false;
	    				}
//	    			});
	    		}

	        	angular.forEach(vm.model.legalities, function(regulationCheck) {
					angular.forEach(vm.model.duties, function(duty) {
						angular.forEach(duty.dutyCrewDetails, function(crewData) {
							if(crewData.crewProfileId == regulationCheck.crewProfileId
									&& crewData.crewScheduleBlockId == regulationCheck.crewScheduleBlockId ){
								crewData.crewIllegalReasons = regulationCheck.regViolationReasons;
							}
						});
					});
	        	});

	    	}
	    }

    vm.exportExcel = function () {
		  console.log("exportExcel dutySheetHidePersonalDetailsEnabled :", vm.model.dutySheetHidePersonalDetailsEnabled)
      createExportDutyList();
      createExportStandByList()

      if (!vm.model.dutySheetHidePersonalDetailsEnabled){
        var dutySheetData =  alasql("SELECT [num] as [#], [acRegNo] as [A/C REG], [flightNo] as Flight, [origin] as [From], [destination] as [To], [etd] as [ETD], [eta] as [ETA],[operBase] as [Oper Base], [crewType] as [Crew Type], [crewId] as [Crew Id], [crewName] as [Crew Members], [gender] as [Gender], [signIn] as [SignIn], [signOut] as [SignOut], [duration] as [Duty Hrs], [fdp] as [FDP],[appApis] as [APP/APIS], [mobile] as [Mobile],[languages] as [Languages] FROM ? ", [vm.model.exportDutyList]);
        var standbyDetails =  alasql("SELECT [no] as [Seq],[patternName] as [SBY Name], [startTime] as [From], [endTime] as [To], [crewTypeCode] as [Type], [crewId] as [ID], [crewName] as [Name], [mobileNo] as [Phone no.], [totFlyingDuration] as [Fly Hrs] FROM ? ",[vm.model.exportStandbyList]);
      }else{
        var dutySheetData =  alasql("SELECT [num] as [#], [acRegNo] as [A/C REG], [flightNo] as Flight, [origin] as [From], [destination] as [To], [etd] as [ETD], [eta] as [ETA],[operBase] as [Oper Base], [crewType] as [Crew Type], [crewId] as [Crew Id], [crewName] as [Crew Members], [signIn] as [SignIn], [signOut] as [SignOut], [duration] as [Duty Hrs], [fdp] as [FDP],[appApis] as [APP/APIS], [languages] as [Languages] FROM ? ", [vm.model.exportDutyList]);
        var standbyDetails =  alasql("SELECT [no] as [Seq],[patternName] as [SBY Name], [startTime] as [From], [endTime] as [To], [crewTypeCode] as [Type], [crewId] as [ID], [crewName] as [Name], [totFlyingDuration] as [Fly Hrs] FROM ? ",[vm.model.exportStandbyList]);
      }

      var opts = [{sheetid:'Duty Sheet',header:true},{sheetid:'Standby Details',header:true}];

      alasql("SELECT * INTO XLSX('duty_sheet'+ ? +'.xlsx',?) FROM ? ", [vm.model.searchCriteria.fromDate,opts,[dutySheetData, standbyDetails]]);

      clearData();
    };

    function createExportDutyList() {
      var resultData = [];
      var dataRow = [];

      for (var i = 0; i < vm.dutyList.length; i++) {
        dataRow = [];

        angular.forEach(vm.dutyList[i].dutyBlockDetails, function (value, key) {
          for (var k = 0; k < value.dutyFlightDetails.length; k++) {
            resultData = [];
            resultData.num = "";
            resultData.acRegNo = value.dutyFlightDetails[k].acRegNo != null ? value.dutyFlightDetails[k].acRegNo : "";
            resultData.flightNo = value.dutyFlightDetails[k].flightNo != null ? value.dutyFlightDetails[k].flightNo : "";
            resultData.origin = value.dutyFlightDetails[k].origin != null ? value.dutyFlightDetails[k].origin : "";
            resultData.destination = value.dutyFlightDetails[k].destination != null ? value.dutyFlightDetails[k].destination : "";

            resultData.etd = value.dutyFlightDetails[k].departureTimeStr != null ? value.dutyFlightDetails[k].departureTimeStr : "";
            resultData.eta = value.dutyFlightDetails[k].arrivalTimeStr != null ? value.dutyFlightDetails[k].arrivalTimeStr : "";
            resultData.crewType = "";
            resultData.crewName = "";
            resultData.appApis = "";
            resultData.mobile = "";
            resultData.languages = "";
            resultData.gender = "";
            resultData.signIn = "";
            resultData.signOut = "";

            dataRow.push(resultData);
          }
        });

        angular.forEach(vm.dutyList[i].dutyCrewDetails, function (value, key) {

          var crewDetails = (value.crewName != null ? value.crewName : " ") + " - " + (value.fleetTypes != null ? value.fleetTypes : " ") + " - " + (value.lateMin != null ? value.lateMin : " ") + " - " +  (value.checkInTime != null ? value.checkInTime : " ");

          if (key < dataRow.length) {
            dataRow[key].crewId = value.crewId != null ? value.crewId : "";
            dataRow[key].duration = value.duration !=null ? value.duration :"";
            dataRow[key].crewName = crewDetails != null ? crewDetails : "";
            dataRow[key].crewType = value.crewType != null ? value.crewType : "";
            dataRow[key].appApis = value.appCountries != null ? Object.keys(value.appCountries).join(",") : "";
            dataRow[key].mobile = value.contactNumber != null ? value.contactNumber : "";
            dataRow[key].languages = value.languageCode != null ? value.languageCode : "";
            dataRow[key].gender = value.gender != null ? value.gender : "";
            dataRow[key].signIn = value.singInTimeStr != null ? value.singInTimeStr : "";
            dataRow[key].signOut = value.signOutTimeStr != null ? value.signOutTimeStr : "";
            dataRow[key].operBase = value.operBase != null ? value.operBase : "";
            dataRow[key].fdp = value.fdp != null ? value.fdp : "";
          } else {

            resultData = [];
            resultData.num = "";
            resultData.acRegNo = "";
            resultData.flightNo = "";
            resultData.origin = "";
            resultData.destination = "";
            resultData.etd = "";
            resultData.eta = "";
            resultData.crewId = value.crewId != null ? value.crewId : "";
            resultData.duration = value.duration !=null ? value.duration :"";
            resultData.crewType = value.crewType != null ? value.crewType : "";
            resultData.crewName = crewDetails != null ? crewDetails : "";
            resultData.appApis = value.appCountries != null ? Object.keys(value.appCountries).join(",") : "";
            resultData.mobile = value.contactNumber != null ? value.contactNumber : "";
            resultData.languages = value.languageCode != null ? value.languageCode : "";
            resultData.gender = value.gender != null ? value.gender : "";
            resultData.signIn = value.singInTimeStr != null ? value.singInTimeStr : "";
            resultData.signOut = value.signOutTimeStr != null ? value.signOutTimeStr : "";
            resultData.operBase = value.operBase != null ? value.operBase : "";
            resultData.fdp = value.fdp != null ? value.fdp : "";

            dataRow.push(resultData);
          }
        });

        if(dataRow && dataRow[0]){
          dataRow[0].num = i+1;
        }

        angular.forEach(dataRow, function (value, key) {
          vm.model.exportDutyList.push(value);
        });
        resultData = [];
        vm.model.exportDutyList.push(resultData);

      }
    }

    function createExportStandByList() {
      var rowData = [];
      angular.forEach(vm.model.otherDuties.standByDetails, function (value, key) {
        rowData = [];
        rowData.no = key+1;
        rowData.patternName = value.patternName;
        rowData.startTime = value.startTime;
        rowData.endTime = value.endTime;
        rowData.crewTypeCode = value.crewTypeCode;
        rowData.crewId = value.crewId;
        rowData.crewName = value.crewName;
        rowData.mobileNo = value.mobileNo;
        rowData.totFlyingDuration = value.totFlyingDuration;

        vm.model.exportStandbyList.push(rowData);

      });
      vm.model.exportStandbyList.push(rowData);
    }

    function clearData() {
      vm.model.exportDutyList = [];
      vm.model.exportStandbyList = [];
    }

		// to hide and show bottom panel
		vm.clickOnBottomPanelView = function() {
			vm.model.showBottomPanel = !vm.model.showBottomPanel;
		};

		// when change field in search
		vm.changeSearchField = function(searchParams, flag, params, viewValue) {
			if (flag === 'fromTime') {
				if (!isValidTime(searchParams.fromTime)) {
					vm.model.masterList.fromTimeInvalid = true;
				} else {
					vm.model.masterList.fromTimeInvalid = false;
					if (!isFromDateBeforeToDate()) {
						vm.model.searchCriteria.toTime = vm.model.searchCriteria.fromTime;
					}
				}
			} else if (flag === 'toTime') {
				if (!isValidTime(searchParams.toTime)) {
					vm.model.masterList.toTimeInvalid = true;
				} else {
					vm.model.masterList.toTimeInvalid = false;
					if (!isFromDateBeforeToDate()) {
						vm.model.searchCriteria.fromTime = vm.model.searchCriteria.toTime;
					}
				}
			} else if (flag === 'fromDate'
					&& vm.model.searchCriteria.fromDate != null
					&& vm.model.searchCriteria.fromDate != '') {
				var foD = moment(vm.model.searchCriteria.fromDate, 'DD/MM/YYYY');
				vm.model.searchCriteria.toDate = vm.model.searchCriteria.fromDate;
			} else if(flag === 'matchingIndex'){
        setMatchingIndexForAirports(viewValue);
      }
		};

    function setMatchingIndexForAirports(viewValue){
      if(viewValue !== " " && viewValue!== null) {
        angular.forEach(vm.model.masterList.airportList, function(apt) {
          apt.matchingIndex = apt.airPortCode.toLowerCase().indexOf(viewValue.toLowerCase());
        })
      }
    }

		// check from date and to date
		function isFromDateBeforeToDate() {
			return moment(
					vm.model.searchCriteria.fromDate + " "
							+ vm.model.searchCriteria.fromTime,
					"DD/MM/YYYY HH:mm").isBefore(
					moment(vm.model.searchCriteria.toDate + " "
							+ vm.model.searchCriteria.toTime,
							"DD/MM/YYYY HH:mm"));
		}

		// convert string date to the Date object
		function convertStringDateToDate(strDate) {
			var date = "";
			if (strDate != null && strDate != undefined && strDate != "") {
				var dateString = strDate.split("/");
				date = new Date(parseInt(dateString[2]),
						parseInt(dateString[1]) - 1, parseInt(dateString[0]));
			}
			return date;
		}
		;

		// validate time
		function isValidTime(time) {
			var regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
			return regex.test(time);
		}
		;

		// submit search
		vm.submitSearchDuties = function(params) {
			if (!vm.model.masterList.fromTimeInvalid && !vm.model.masterList.toTimeInvalid) {
				resetAirport(params);
				vm.model.searchCriteria = params;
        vm.model.masterList.searchFrom = moment(vm.model.searchCriteria.fromDate,'DD/MM/YYYY').format('Do MMMM YYYY');
				vm.model.selectedDuty = {};
				DutySheetService.setDutySheetSearchRequest(vm.model.searchCriteria);
				getDuties();
				getOtherDuties();
        vm.refreshTimer();
			}
		};

		function resetAirport(params){
			if(params.airport){
				try{
					if(!params.airport.trim()){
						params.airport = null;
					}
				}catch(e){
					console.log("airport value exist");
				}
			}
		}

		// load grid data
		function getDuties() {
			DutySheetService.searchDuties(function(duties,legalityCheckDuties, dutySheetHidePersonalDetailsEnabled) {
			  vm.model.dutySheetHidePersonalDetailsEnabled = dutySheetHidePersonalDetailsEnabled;
				vm.dutyList = DutySheetService.getFormattedDuties(duties);
				vm.model.duties=[];
				vm.limitIndex = 30;
				for(var i=0, index=0; i < (vm.dutyList.length < vm.limitIndex ? vm.dutyList.length : vm.limitIndex); i++){
//	           		 $timeout(function(){
	           			 vm.model.duties.push(vm.dutyList[index]);
	           			 index++;
//	           		 });
	           	 }
				vm.model.searchPanelToggle = false;
				vm.model.initialSearchDone = true;

				DutySheetService.searchDutiesLegality(legalityCheckDuties ,
						function(regulation){
						vm.model.legalities = regulation;
						angular.forEach(vm.model.legalities, function(regulationCheck) {
								angular.forEach(vm.model.duties, function(duty) {
									angular.forEach(duty.dutyCrewDetails, function(crewData) {
										if(crewData.crewProfileId == regulationCheck.crewProfileId
												&& crewData.crewScheduleBlockId == regulationCheck.crewScheduleBlockId ){
											crewData.crewIllegalReasons = regulationCheck.regViolationReasons;
										}
									});
								});
						});
				 },
						function(error) {
							MessageService.error(error);
				});

			}, function(error) {
				MessageService.error(error);
			});
		};


		function clearSearchPanel() {
			vm.model.searchCriteria = DutySheetService
					.getInitialSearchCrieteria();
		};


		// load bottom grid data
		function getOtherDuties() {
			getStandByDetails();
			getDeadHeadingDetails();
			getReadyToWorkDetails();
			getReportSickDetails();
			getOtherDutyTypeDetails();
		};


		// load stand by details
		function getStandByDetails() {
			DutySheetService.searchStandByDetails(function(standByDetails) {
				vm.model.otherDuties.standByDetails = standByDetails;
			}, function(error) {
				MessageService.error(error);
			});
		};


		// load dead heading details
		function getDeadHeadingDetails() {
			DutySheetService.searchDeadHeadingDetails(function(deadHeadingDetails) {
        setGdPrintTemplatesForDHD(deadHeadingDetails);
				vm.model.otherDuties.deadHeadingDetails = deadHeadingDetails;
			}, function(error) {
				MessageService.error(error);
			});
		};


    function setGdPrintTemplatesForDHD(deadHeadingDetails) {
      for (var i = 0; i < deadHeadingDetails.length; i++) {
        deadHeadingDetails[i].flightHubs = [deadHeadingDetails[i].flightHub];
      }
    }


		// load ready to work details
		function getReadyToWorkDetails() {
			DutySheetService.searchReadyToWorkDetails(function(readyToWorkDetails) {
				vm.model.otherDuties.readyToWorkDetails = readyToWorkDetails;
			}, function(error) {
				MessageService.error(error);
			});
		};

    // load report sick details
		function getReportSickDetails() {
      DutySheetService.searchReportSickDetails(function(reportSickDetails) {
        vm.model.otherDuties.reportSickDetails = reportSickDetails;
      }, function(error) {
        MessageService.error(error);
      });
    }

		// load other duty type details
		function getOtherDutyTypeDetails() {
			DutySheetService.searchOtherDutyTypeDetails(function(otherDutyTypeDetails) {
				vm.model.otherDuties.otherDutyTypeDetails = otherDutyTypeDetails;
			}, function(error) {
				MessageService.error(error);
			});
		};


		// when click on the row
		vm.selectMainGridRow = function(selectedRowData, flag) {
			if (flag === 'rowSelect' || flag === 'crewSelect') {
				//navigate to crew schedule if crew click
				onNavigateCrewSchedule(getSelectedCrewId(selectedRowData));
				deselectDuties();
				vm.model.selectedDuty = selectedRowData;
				deselectDHDs(true);
				selectedRowData.isSelected = true;
				selectedRowData.popOverFlag = false;

			} else if (flag === 'rightClick') {
				if (openedPopoverBlock && openedPopoverBlock !== selectedRowData) {
					openedPopoverBlock.popOverFlag = false;
				}
				openedPopoverBlock = selectedRowData;
				selectedRowData.popOverFlag = true;
			} else if (flag === 'journeyLog') {
				selectedRowData.popOverFlag = false;
				journeyLog();
			} else if (flag === 'printGd') {
				selectedRowData.popOverFlag = false;
				openedPopoverBlock = null;
				lastRightClickedBlock = selectedRowData;
				gdPrint();
			}else if(flag ==='appFlights'){
				vm.model.masterList.tooltipFlights = selectedRowData;
			}
		};

		//get crew Id of the Clicked/Selected crew and reset isSelect flag
		function getSelectedCrewId(selectedRowData) {
			var crewId = null;
			for(var i=0;i< selectedRowData.dutyCrewDetails.length;i++) {
				if(selectedRowData.dutyCrewDetails[i].isSelect){
					crewId = selectedRowData.dutyCrewDetails[i].crewId;
					selectedRowData.dutyCrewDetails[i].isSelect = false;
					break;
				}
			}
			return crewId;
		}

		function deselectDuties() {
			vm.model.selectedDuty = {};
			if (!!vm.model.duties && vm.model.duties.length > 0) {
				for (var i = 0; i < vm.model.duties.length; i++) {
					vm.model.duties[i].isSelected = false;
				}
			}
		}
		;

		function deselectDHDs(isDeselectAll) {
			vm.model.selectedDHD = {};
			if (isDeselectAll) {
				vm.model.otherDuties.selectedDHDRowIndex = -1;
			} else if (vm.model.otherDuties.selectedDHDRowIndex > -1) {
				vm.model.selectedDHD = vm.model.otherDuties.deadHeadingDetails[vm.model.otherDuties.selectedDHDRowIndex];
			}
			if (!!vm.model.otherDuties.deadHeadingDetails
					&& vm.model.otherDuties.deadHeadingDetails.length > 0) {
				for (var i = 0; i < vm.model.otherDuties.deadHeadingDetails.length; i++) {
					if (vm.model.otherDuties.selectedDHDRowIndex == i) {
						vm.model.otherDuties.deadHeadingDetails[i].isSelected = true;
					} else {
						vm.model.otherDuties.deadHeadingDetails[i].isSelected = false;
					}
				}
			}
		}
		;

		vm.doAction = function(flag) {
			if(flag.match(/^navigateCrewSchd-*/) ){
				onNavigateCrewSchedule(flag.replace('navigateCrewSchd-', ''));
			} else if (flag == 'tickCheckBox') {
				vm.model.bottomLastScrollPosition = $("#duty_sheet_bottom_panel").scrollTop();
				setSelectedStandByList();
			} else if (flag == 'email') {
				emailDuty();
			} else if (flag == 'journeyLog') {
				journeyLog();
			} else if (flag == 'print') {
				printDutySheet();
			} else if (flag == 'GDPrint') {
				lastRightClickedBlock = null;
				gdPrint();
			} else if (flag == 'crewing') {
				onNavigateCrewing();
			} else if (flag == 'selectDHD') {
				deselectDuties();
				deselectDHDs(false);
			}
		};

		// email
		function emailDuty() {
			var blockIds = getblockIdsBySelectedDutyOrDHD();
			if (!!blockIds.length > 0) {
				DutySheetService.sendEmail(blockIds, function(response) {
					// set search adapted data
					if (response.success) {
						deselectDuties();
						deselectDHDs(true);
						MessageService.success('Email is sent Successfully!');
						vm.model.selectedDuty = {};
					} else if (!response.success) {
						MessageService.error(response.error);
					}
				}, function() {
					console.log('Error occurs while sending email.');
				});
			} else {
				MessageService
						.error("Please Select at least one duty for send email.");
			}
		}
		;

		//get blockIds from the selected duty or dhd
		function getblockIdsBySelectedDutyOrDHD() {
			var blockIds = [];
			if (!!vm.model.selectedDuty.dutyBlockDetails
					&& vm.model.selectedDuty.dutyBlockDetails.length > 0) {
				for (var i = 0; i < vm.model.selectedDuty.dutyBlockDetails.length; i++) {
					blockIds
							.push(vm.model.selectedDuty.dutyBlockDetails[i].blockId
									+ '');
				}
			} else if (!!vm.model.selectedDHD.blockId) {
				blockIds.push(vm.model.selectedDHD.blockId);
			}
			return blockIds;
		}
		;

		//set selected standbys
		function setSelectedStandByList() {
			vm.model.bottomLastScrollPosition = $("#duty_sheet_bottom_panel").scrollTop();
			vm.model.selectedStandBy = [];
			if (vm.model.otherDuties.standByDetails.length > 0) {
				for (var i = 0; i < vm.model.otherDuties.standByDetails.length; i++) {
					if (vm.model.otherDuties.standByDetails[i].isSelected) {
						vm.model.selectedStandBy
								.push(vm.model.otherDuties.standByDetails[i]);
					}
				}
			}
			$("#duty_sheet_bottom_panel").scrollTop(vm.model.lastScrollPosition);
		}
		;

		// navigate to crewing
		function onNavigateCrewing() {
			if (!!vm.model.selectedStandBy
					&& vm.model.selectedStandBy.length > 0) {

				var mo = moment(vm.model.searchCriteria.toDate, applicationConstants.SETTINGS.DATE_FORMAT);
	            var moEnd = moment(mo.endOf("month"));
				var endDateOfMonth = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
				var moStart = moment(mo.startOf("month"));
				var startDateOfMonth = moStart.format(applicationConstants.SETTINGS.DATE_FORMAT);

				var _loadCrewingParams = {
					fromDate : startDateOfMonth,
					toDate : endDateOfMonth,
					crewIds : DutySheetService
							.getCrewIdsBySelectedStandBy(vm.model.selectedStandBy)
				};

				var navigateToCrewing = function(paramToSend) {
					var tabName = 'crewing';
					StorageServices.setTabData(tabName, 'crewingParams',
							paramToSend);
					TabService.gotoTab(tabName, {
						mode : 'DS_Navigate',
						time : new Date().getTime()
					});
				};
				navigateToCrewing(_loadCrewingParams);
			} else {
				MessageService
						.error("Please select at least one Standby duty.");
			}
		}

		// navigate to crew Schedule
		function onNavigateCrewSchedule(crewId) {
			if (!!crewId && crewId!= null) {
				var _loadCrewScheduleParams = {
					crewId : crewId,
					fromDate : moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY").startOf('month').format("DD/MM/YYYY"),
					toDate : moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY")
				};

				var navigateToCrewSchedule = function(paramToSend) {
					var tabName = 'crewSchedule';
					StorageServices.setTabData(tabName, 'crewingParams',
							paramToSend);
					TabService.gotoTab(tabName, {
						crewId : crewId,
						time   : (new Date()).getTime()
					});
				};
				navigateToCrewSchedule(_loadCrewScheduleParams);
			}
		};

		function gdPrint() {

			if (vm.model.selectedDuty.isSelected || (!!vm.model.selectedDHD && (!!vm.model.selectedDHD.blockId || !!vm.model.selectedDHD.crewSchEventId))) {
				var blockId = vm.model.selectedDuty.isSelected ? vm.model.selectedDuty.dutyBlockDetails[0].blockId
						: vm.model.selectedDHD.blockId;
				var crewScheduleEventId = vm.model.selectedDuty.isSelected ? vm.model.selectedDuty.dutyBlockDetails[0].crewSchEventId :
					vm.model.selectedDHD.crewSchEventId;
				var selectedCrewTypes = "";

				//set tab data when print separate gd for crew types
				if(vm.model.printSeparateGDForCrewTypes){
					var param = {
				            title: 'Select Required Crew Types To Print In GD',
				            crewTypes : getSelectedCrewTypeObjectList(vm.model.selectedDuty.isSelected ?
				            		vm.model.selectedDuty.dutyCrewDetails : vm.model.masterList.crewTypeList)
				        };
						PopupManager.openModal('GD_CREW_TYPE_SELECT_POPUP', param,
								confirmCrewTypeSelection);
				}else{
				      var param = {
                				            title: 'Select Required Template To Print In GD',
                				            clients : getSelectedGDPrintClientsList(vm.model.selectedDuty.isSelected ?
                				            		vm.model.selectedDuty.dutyBlockDetails: [], vm.model.carrierCode)
                				        };
                PopupManager.openModal('GD_TEMPLATE_SELECT_POPUP', param,
                  confirmGDTemplateSelection);
					//navigateToGDWindow(blockId, null, crewScheduleEventId);
				}
			} else {
				MessageService.error("Please select duty.");
			}
		};

		//get crew Types as object list
		function getSelectedCrewTypeObjectList(dutyCrewDetails){
			var crewTypes = [], crewTypeObjects = [];
			//set req crew types in the selected duty
			for(var i = 0; i < dutyCrewDetails.length ; i++){
				var crewTypeCode = dutyCrewDetails[i].crewType || dutyCrewDetails[i].crewTypeCode;
				if((crewTypes.indexOf(crewTypeCode) == -1 ) && !!crewTypeCode){
					crewTypes.push(crewTypeCode);
					crewTypeObjects.push({crewTypeCode : crewTypeCode, isSelected :true});
				}
			}
			return crewTypeObjects;
		};

    function getSelectedGDPrintClientsList(dutyBlockdetails, carrierCode){
      var clients = [],  clientsObjects = [];
      clientsObjects.push({clientCode : carrierCode, isSelected : true});
      clients.push(carrierCode);
      for(var i = 0; i < dutyBlockdetails.length ; i++){
        for (var j = 0; j < dutyBlockdetails[i].dutyFlightDetails.length; j++) {
          var clientCode = dutyBlockdetails[i].dutyFlightDetails[j].flightHub;
          if (clients.indexOf(clientCode) == -1) {
            clientsObjects.push({clientCode : clientCode, isSelected : false});
            clients.push(clientCode);
          }
        }
      }
      return clientsObjects;
    };

		function getSelectedBlockForPrint() {
			return lastRightClickedBlock || vm.model.selectedDuty.dutyBlockDetails[0];
		};

		function confirmCrewTypeSelection(crewTypes) {
			if (!!crewTypes) {
				var crewScheduleEventId = vm.model.selectedDuty.isSelected ? getSelectedBlockForPrint().crewSchEventId : vm.model.selectedDHD.crewSchEventId;
				navigateToGDWindow(vm.model.selectedDuty.isSelected ? getSelectedBlockForPrint().blockId
						: vm.model.selectedDHD.blockId, crewTypes, crewScheduleEventId, null);
			}
		};

		function confirmGDTemplateSelection(clients) {
    			if (!!clients) {
    				var crewScheduleEventId = vm.model.selectedDuty.isSelected ? getSelectedBlockForPrint().crewSchEventId : vm.model.selectedDHD.crewSchEventId;
    				navigateToGDWindow(vm.model.selectedDuty.isSelected ? getSelectedBlockForPrint().blockId
    						: vm.model.selectedDHD.blockId, null, crewScheduleEventId, clients);
    			}
    		};

		function navigateToGDWindow(blockId, crewTypes, crewScheduleEventId, clients){
			var tabData = { blockId : blockId, crewScheduleEventId : crewScheduleEventId};
			var selectedCrewTypes = getSelectedCrewTypes(crewTypes);
			if(!!selectedCrewTypes && selectedCrewTypes !== ""){
				tabData.crewTypes = selectedCrewTypes;
			}
			var selectedTemplate = getSelectedGDTemplate(clients);
			//print gd
			if(!vm.model.showNewGD){
				var tabName = 'printGD';
				StorageServices.setTabData(tabName, 'printGDParams', tabData);
				TabService.gotoTab(tabName, tabData, 'popup');
			}else{
				redirectToNewGDReport(blockId, selectedCrewTypes, crewScheduleEventId, selectedTemplate);
			}
		};

		//get selected crew type as comma separated string
		function getSelectedCrewTypes(crewTypes){
			var selectedCrewTypes = [];
			var crewTypeStr = null;
			if(!!crewTypes){
				for(var i=0; i < crewTypes.length; i++){
					if(crewTypes[i].isSelected){
						selectedCrewTypes.push(crewTypes[i].crewTypeCode);
					}
				}
				crewTypeStr = selectedCrewTypes.join(',');
			}
			return crewTypeStr;
		};

    function getSelectedGDTemplate(clients){
      var selectedClient = null;
      var crewTypeStr = null;
      if(!!clients){
        for(var i=0; i < clients.length; i++){
          if(clients[i].isSelected){
            return clients[i].clientCode;
          }
        }
      }
      return null;
    };


		//redirect to new gD Report
		function redirectToNewGDReport(blockId, crewTypes, crewScheduleEventId, client) {
			var rptDesign = client.toLowerCase() + "_gd_report.rptdesign";
			var url = CommonLogicService.getReportUrl(rptDesign, getParamMap(blockId, crewTypes, crewScheduleEventId), 'Y', 'Y');
			window.open(url);
		};

		//set param map
		function getParamMap(blockId, crewTypes, crewScheduleEventId){
			var searchParamMap = {};
			searchParamMap["blockId"] = blockId;
			if(!!crewScheduleEventId){
				searchParamMap["crewScheduleEventId"] = crewScheduleEventId;
			}
			if(!!crewTypes || crewTypes == ""){
				searchParamMap["crewTypes"] = crewTypes;
			}
			searchParamMap["__format"] =  'pdf';
			searchParamMap["__dpi"] =  96;
			searchParamMap["__pageoverflow"] =  1;
			searchParamMap["__overwrite"] =  false;
			return searchParamMap;
		};



		function printDutySheet() {
		  console.log("printDutySheet =====")
			if(vm.model.initialSearchDone){
				var tabName = 'printDutySheet';
				StorageServices.setTabData(tabName, 'printDutySheetParams',
						vm.model.searchCriteria.fromDate,
						vm.model.searchCriteria.fromTime,
						vm.model.searchCriteria.toDate,
						vm.model.searchCriteria.toTime,
						vm.model.searchCriteria.JourneyLogNo,
						vm.model.searchCriteria.crewType == null ? null
								: vm.model.searchCriteria.crewType.desc,
						vm.model.searchCriteria.airport == null ? null
								: vm.model.searchCriteria.airport.airPortCode,
						vm.model.searchCriteria.aircraftType == null ? null
								: vm.model.searchCriteria.aircraftType.modelNumber,
						vm.model.searchCriteria.isDestinationOnly,
						vm.model.dutySheetHidePersonalDetailsEnabled,
           vm.model.searchCriteria.base);
				TabService
						.gotoTab(
								tabName,
								{
									fromDateStr : vm.model.searchCriteria.fromDate,
									fromTimeStr : vm.model.searchCriteria.fromTime,
									toDateStr : vm.model.searchCriteria.toDate,
									toTimeStr : vm.model.searchCriteria.toTime,
									journeyLogNumberStr : vm.model.searchCriteria.JourneyLogNo,
									crewType : vm.model.searchCriteria.crewType == null ? null
											: vm.model.searchCriteria.crewType.code,
									airPortCode : vm.model.searchCriteria.airport == null ? null
											: vm.model.searchCriteria.airport.airPortCode,
									aircraftModel : vm.model.searchCriteria.aircraftType == null ? null
											: vm.model.searchCriteria.aircraftType.modelNumber,
									getOtherGroundDuties : true,
									isDestinationOnly : vm.model.searchCriteria.isDestinationOnly,
                  base : vm.model.searchCriteria.base,
                  dutySheetHidePersonalDetailsEnabled: vm.model.dutySheetHidePersonalDetailsEnabled
								}, 'popup');

			}else{
				MessageService
				.error("Please Search Duties For Print Duty Sheet.");
			}
		};

		function journeyLogPrint() {
			if (!!vm.model.selectedDHD.blockId
					|| !!vm.model.selectedDuty.dutyBlockDetails) {
				var _loadPrintJourneyLogParams = getJourneyLogPrintParams();

				var navigateToPrintJourneyLog = function(paramToSend) {
					var tabName = 'printJourneyLog';
					StorageServices.setTabData(tabName, 'printJourneyLog',
							paramToSend);
					TabService.gotoTab(tabName, {
						time : new Date().getTime()
					});
				};
				navigateToPrintJourneyLog(_loadPrintJourneyLogParams);

			} else {
				MessageService
						.error("Please Select duty for printing journey Log.");
			}
		}
		;

		function getJourneyLogPrintParams() {
			var printJourneyLogFlightDetails = {};
			if (!!vm.model.selectedDHD.blockId) {
				printJourneyLogFlightDetails = DutySheetService
						.getFormattedJourneyLogPrintParamByDHD(vm.model.selectedDHD);
			} else if (!!vm.model.selectedDuty.dutyBlockDetails) {
				printJourneyLogFlightDetails = DutySheetService
						.getFormattedJourneyLogPrintParamByDuty(vm.model.selectedDuty);
			}
			return printJourneyLogFlightDetails;
		}

		function journeyLog() {
			if(vm.model.selectedDuty.isSelected ||
					(!!vm.model.selectedDHD && !!vm.model.selectedDHD.blockId || !!vm.model.selectedDHD.crewSchEventId)) {
				if(!vm.model.selectedDuty.isSelected){
					vm.model.selectedDuty.dutyBlockDetails = [];
					vm.model.selectedDuty.dutyBlockDetails.push(vm.model.selectedDHD);
				}
				var params = DutySheetService
						.getJourneyLogRq(vm.model.selectedDuty);
				DutySheetService
						.getJourneyLogData(
								params,
								function(response) {
									if (response.success) {
										var details = {};
										details.journeyDetails = response.journeyDetails;
										details.joiningCrewCollection = response.joiningCrewCollection;
										details.selectedBlock = vm.model.selectedDuty;
										if(!!response.block && !!response.block.blockId){
											if(!!details.selectedBlock.dutyBlockDetails && details.selectedBlock.dutyBlockDetails.length > 0){
												details.selectedBlock.dutyBlockDetails[0].blockId = response.block.blockId;
												details.selectedBlock.dutyBlockDetails[0].version = response.block.version;
											}
										}
										details.selectedDHD = vm.model.selectedDHD;
										if (details.journeyDetails.length > 0) {
											details.title = 'Journey Log';
											PopupManager.openModal('JOURNEY_LOG_POPUP', details, confirmJourneyLogPopup);
										} else {
											MessageService
													.warning('No Schedule trainings');
										}

									}
								}, function(error) {
									MessageService.error(error);
								});

			} else {
				MessageService.error("Please select duty.");
			}

		}

    var currentTimeTimer;
		vm.refreshTimer = function setRefreshTimer(){

      if(vm.model.refreshData){
        clearTimer();
        currentTimeTimer = $interval(function () {
          //vm.model.lastScrollPosition = $("#duty_sheet_main_grid").scrollTop();
          vm.submitSearchDuties(vm.model.searchCriteria);
          scrollToPosition();
          }, vm.model.refreshingTime);
        }else{
        if (!!currentTimeTimer) {
          $interval.cancel(currentTimeTimer);
        }
      }
    };

    function scrollToPosition(){
      $timeout(function(){
        //$("#duty_sheet_main_grid").scrollTop(vm.model.lastScrollPosition);
      },6000);
    }

    function clearTimer(){
      if (!!currentTimeTimer) {
        $interval.cancel(currentTimeTimer);
      }
    }


		function confirmJourneyLogPopup(pass) {
      if(pass === 'CLOSE'){
        if(vm.model.searchCriteria){
          vm.submitSearchDuties(vm.model.searchCriteria);
        }
      }
    }

    clearTimer();

		function closeOpenedPopover() {
			if (openedPopoverBlock) {
				$timeout(function() {
					openedPopoverBlock.popOverFlag = false;
					openedPopoverBlock = null;
				}, 0);
			}
		}
		document.addEventListener('scroll', closeOpenedPopover, true);
		$scope.$on('$destroy', function() {
			document.removeEventListener('scroll', closeOpenedPopover, true);
		});

		// get master data list
		(function() {
			// crew type master codes
			CommonMasterData.getCrewTypeMasterCodes(function(
					crewTypeMasterCodes) {
				vm.model.masterList.crewTypeMasterCodes = crewTypeMasterCodes;
			}, function() {
				console.log('Crew type Master Codes retrieval error');
			});
			// aircraft types
			CommonMasterData.getAircraftModels(function(aircrafts) {
				vm.model.masterList.aircraftTypes = aircrafts;
			}, function() {
				console.log('Aircraft types retrieval error');
			});
			// airportList
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function() {
				console.log('Airport List retrieval error');
			});
			//delay codes
			CommonMasterData
					.getDelayCodeDetails(
							function(response) {
								vm.model.masterList.delayCodeDetails = response.delayCodeAdaptDTOs;
							}, function() {
							});
			//get showing new gd flag
			CommonMasterData.getShowNewGD(function(flag) {
				vm.model.showNewGD = flag;
			}, function(error) {
				console.log('GD Showing Flag retrieval error');
			});
			//print separate gd for crew type flag
			CommonMasterData.getPrintSeparateGDForCrewTypes(function(flag) {
				vm.model.printSeparateGDForCrewTypes = flag;
			}, function(error) {
				console.log('Print Seperate GD For Crew Types Flag retrieval error');
			});
      // baseList
      CommonMasterData.getCrewBaseList(function(baseList) {
        vm.model.masterList.baseList = baseList;
      }, function() {
        console.log('Base List retrieval error');
      });
       // crew type codes
		CommonMasterData.getCrewTypeList(function(crewTypeList) {
			vm.model.masterList.crewTypeList = crewTypeList;
		}, function() {
			console.log('Crew Type Code list retrieval error');
		});

		CommonMasterData.getDutySheetRefreshingTime(function (time) {
      vm.model.refreshingTime = time;
    }, function() {
      console.log('duty sheet refreshing timeline retrieval error');

    });

      CommonMasterData.getCarrierCode(function (code) {
        vm.model.carrierCode = code;
      }, function() {
        console.log('carrier code retrieval error');

      });

		})();
	}
}());
